import { RegisterVerifiedCompanyWithBizsolMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const registerVerifiedCompanyWithBizsolHandler =
  graphql.mutation<RegisterVerifiedCompanyWithBizsolMutation>(
    "registerVerifiedCompanyWithBizsol",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          registerVerifiedCompanyWithBizsol: {
            token: {
              id_token: "mock_id_token",
              access_token: "mock_access_token",
              refresh_token: "mock_refresh_token",
              token_type: "Bearer",
            },
          },
        },
      });
    }
  );
